import AudioWaveOptions, { AudioWaveOptionsProps } from './AudioWaveOptions';
import connect from './connect';

export default connect(AudioWaveOptions);
export { AudioWaveOptionsProps };
